// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1128":"56d1f5034e1e3936","1386":"0626a9ae055d683e"}[chunkId] + ".css";
};